export function mixin(target, source) {
    Object.getOwnPropertyNames(source.prototype).forEach((name) => {
        Object.defineProperty(target.prototype, name, Object.getOwnPropertyDescriptor(source.prototype, name));
    });
}
//# sourceMappingURL=mixin.js.map